import React, { RefObject } from 'react';

const intersectionObserverPolyfill = () => import('intersection-observer');

export const useIntersecting = ({
    domNode,
    ref,
    rootMargin = '400px',
}: {
    domNode?: HTMLElement | null;
    ref?: RefObject<HTMLElement>;
    rootMargin?: string;
}) => {
    const observerRef = React.useRef(null);
    const [isIntersecting, setIsIntersecting] = React.useState(false);

    React.useEffect(() => {
        const element = domNode || ref?.current;
        let observerNode =
            observerRef.current as unknown as IntersectionObserver;

        const loadIntersectionObserver = async () => {
            if (element) {
                await intersectionObserverPolyfill();
                const onIntersection = (
                    entries: IntersectionObserverEntry[],
                ) => {
                    if (entries[0].intersectionRatio <= 0) return;

                    setIsIntersecting(true);
                    observerNode.disconnect();
                };
                observerNode = new IntersectionObserver(onIntersection, {
                    rootMargin,
                });

                observerNode.observe(element);
            }
        };

        loadIntersectionObserver();

        return () => {
            observerNode?.disconnect();
        };
    }, [domNode, ref, isIntersecting, rootMargin]);

    return [isIntersecting];
};
